import React from 'react';
import {func} from 'prop-types';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';

import EquipmentTable from './EquipmentTable';

import classes from './DataPanel.module.css';

const EquipmentPanelInsert = ({
    equipment,
    handleDelete,
    handleSearch,
    handleSelect,
    isFullArchitectAllowed,
    onToggleDeleteEquipmentEntityModal,
    selectedEquipment,
    showContextMenu,
    type,
    ...props
}) => {
    return (
        <React.Fragment>
            <ActionBar
                onSearch={(searchTerm) => {handleSearch(searchTerm, type);}}
            >
                <ActionBarItem
                    onClick={handleDelete}
                    type="delete"
                    disabled={!selectedEquipment.length}
                >
                    Delete Equipment
                </ActionBarItem>
            </ActionBar>
            <div className={classes.scrollContainer}>
                <EquipmentTable
                    equipment={equipment}
                    onToggleDeleteEquipmentEntityModal={onToggleDeleteEquipmentEntityModal}
                    isFullArchitectAllowed={isFullArchitectAllowed}
                    showContextMenu={showContextMenu}
                    filterBy={type}
                    handleSelect={handleSelect}
                />
            </div>
        </React.Fragment>
    );
};

EquipmentPanelInsert.defaultProps = {
    handleDelete: () => {},
    handleSearch: () => {},
    handleSelect: () => {}
};

EquipmentPanelInsert.propTypes = {
    handleDelete: func,
    handleSearch: func,
    handleSelect: func
};

export default EquipmentPanelInsert;
